import styles from './styles.module.scss'

import { Helmet } from 'react-helmet';

import { useEffect, useState } from 'react'

import { Button, Card } from 'antd';
import { ButtonQuestion } from '@/components/button/question';
import { sendEvent } from '../../utils/ga';

const add_to_cart_apple = `
gtag('event', 'add_to_cart', {
  currency: 'KRW',
  value: 4100,
  items: [
    {
      item_id: "ITEM_1",
      item_name: "맛있는 사과입니다!",
      item_category: "과일",
      price: 4100,
      quantity: 1
    }
  ]
})
`

const add_to_cart_strawberry = `
gtag('event', 'add_to_cart', {
  currency: 'KRW',
  value: 6590,
  items: [
    {
      item_id: "ITEM_2",
      item_name: "맛있는 딸기입니다!",
      item_category: "과일",
      price: 6590,
      quantity: 1
    }
  ]
})
`

const purchase_apple = `
gtag('event', 'purchase', {
  currency: 'KRW',
  transaction_id: 'T-${Date.now()}',
  value: 4100,
  items: [
    {
      item_id: "ITEM_1",
      item_name: "맛있는 사과입니다!",
      item_category: "과일",
      price: 4100,
      quantity: 1
    }
  ]
})
`

const purchase_strawberry = `
gtag('event', 'purchase', {
  currency: 'KRW',
  transaction_id: 'T-${Date.now()}',
  value: 6590,
  items: [
    {
      item_id: "ITEM_2",
      item_name: "맛있는 딸기입니다!",
      item_category: "과일",
      price: 6590,
      quantity: 1
    }
  ]
})
`

const purchase_apple_strawberry = `
gtag('event', 'purchase', {
  currency: 'KRW',
  transaction_id: 'T-${Date.now()}',
  value: 10690,
  items: [
    {
      item_id: "ITEM_1",
      item_name: "맛있는 사과입니다!",
      item_category: "과일",
      price: 4100,
      quantity: 1
    },
    {
      item_id: "ITEM_2",
      item_name: "맛있는 딸기입니다!",
      item_category: "과일",
      price: 6590,
      quantity: 1
    }
  ]
})
`

export const PageCart = () => {
  const [cartItems, setCartItems] = useState<string[]>([])

  useEffect(() => {
    const startWithApple = window.location.href.includes('item=apple')
    const startWithStrawberry = window.location.href.includes('item=strawberry')

    if (startWithApple) {
      setCartItems(['apple'])
    }

    if (startWithStrawberry) {
      setCartItems(['strawberry'])
    }
  }, [])

  const onCartClick = (e: React.MouseEvent, type: 'apple' | 'strawberry') => {
    const hasAlreadyType = cartItems.includes(type)

    if (hasAlreadyType) {
      alert('이미 장바구니에 담겨있습니다.')
      return false
    }

    if (type === 'apple') {
      sendEvent('add_to_cart', {
        currency: 'KRW',
        value: 4100,
        items: [
          {
            item_id: "ITEM_1",
            item_name: "맛있는 사과입니다!",
            item_category: "과일",
            price: 4100,
            quantity: 1
          },
        ]
      })
    }

    if (type === 'strawberry') {
      sendEvent('add_to_cart', {
        currency: 'KRW',
        value: 6590,
        items: [
          {
            item_id: "ITEM_2",
            item_name: "맛있는 딸기입니다!",
            item_category: "과일",
            price: 6590,
            quantity: 1
          }
        ]
      })
    }

    const nextCartItems = [...cartItems, type]
    setCartItems(nextCartItems)
  }

  const getTotalPrice = () => {
    if (cartItems.includes('apple') && cartItems.includes('strawberry')) {
      return '10,690'
    }

    if (cartItems.includes('apple')) {
      return '4,100'
    }

    if (cartItems.includes('strawberry')) {
      return '6,590'
    }
  }

  const getPurchaseCode = () => {
    if (cartItems.includes('apple') && cartItems.includes('strawberry')) {
      return purchase_apple_strawberry
    }

    if (cartItems.includes('apple')) {
      return purchase_apple
    }

    if (cartItems.includes('strawberry')) {
      return purchase_strawberry
    }
  }

  const onPurchaseClick = (e: React.MouseEvent) => {
    if (cartItems.includes('apple') && cartItems.includes('strawberry')) {
      sendEvent('purchase', {
        currency: 'KRW',
        transaction_id: `T-${Date.now()}`,
        value: 10690,
        items: [
          {
            item_id: "ITEM_1",
            item_name: "맛있는 사과입니다!",
            item_category: "과일",
            price: 4100,
            quantity: 1
          },
          {
            item_id: "ITEM_2",
            item_name: "맛있는 딸기입니다!",
            item_category: "과일",
            price: 6590,
            quantity: 1
          }
        ]
      })

      alert('상품을 구매했습니다.')

      return
    }

    if (cartItems.includes('apple')) {
      sendEvent('purchase', {
        currency: 'KRW',
        transaction_id: `T-${Date.now()}`,
        value: 4100,
        items: [
          {
            item_id: "ITEM_1",
            item_name: "맛있는 사과입니다!",
            item_category: "과일",
            price: 4100,
            quantity: 1
          }
        ]
      })

      alert('상품을 구매했습니다.')

      return
    }

    if (cartItems.includes('strawberry')) {
      sendEvent('purchase', {
        currency: 'KRW',
        transaction_id: `T-${Date.now()}`,
        value: 6590,
        items: [
          {
            item_id: "ITEM_2",
            item_name: "맛있는 딸기입니다!",
            item_category: "과일",
            price: 6590,
            quantity: 1
          }
        ]
      })

      alert('상품을 구매했습니다.')

      return
    }
  }

  return (
    <>
      <Helmet>
        <title>장바구니</title>
      </Helmet>
      <div className={styles.header}>
        <h2>장바구니에 담아주세요</h2>
      </div>
      <div className={styles.description}>
        <p>마음에 드는 과일을 골라주세요</p>
      </div>
      <div className={styles.body}>
        <div className={styles.colLeft}>
          <Card>
            <div className={styles.content}>
              <div className={styles.colLeft}>
                <img className={styles.thumbnail} src="/ga4/apple.jpg"/>
                <p className={styles.author}>Photo by <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/@lenneek?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Elena Koycheva</a> on <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/images/food/apple?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Unsplash</a></p>
              </div>
              <div className={styles.colRight}>
                <div className={styles.rowDescription}>
                  <p className={styles.category}>과일</p>
                  <p className={styles.title}>맛있는 사과입니다!</p>
                  <p className={styles.buy}><span className={styles.unit}>284</span>명의 사용자가 구매했습니다.</p>
                  <hr className={styles.divider}/>
                  <p className={styles.price}>4,100원<span className={styles.unit}>(100g당 410원)</span></p>
                </div>
                <div className={styles.rowAction}>
                  <Button type="primary" onClick={(e) => onCartClick(e, 'apple') } className={styles.btnCart}>장바구니 담기</Button>
                  <ButtonQuestion
                    content={() => {
                      return (
`${add_to_cart_apple}`
                        )
                      }}
                  />
                </div>
              </div>
            </div>
          </Card>
          <div style={{marginTop: '24px'}}></div>
          <Card>
            <div className={styles.content}>
              <div className={styles.colLeft}>
                <img className={styles.thumbnail} src="/ga4/strawberry.jpg"/>
                <p className={styles.author}>Photo by <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/@lenneek?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Elena Koycheva</a> on <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/images/food/apple?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Unsplash</a></p>
              </div>
              <div className={styles.colRight}>
                <div className={styles.rowDescription}>
                  <p className={styles.category}>과일</p>
                  <p className={styles.title}>맛있는 딸기입니다!</p>
                  <p className={styles.buy}><span className={styles.unit}>284</span>명의 사용자가 구매했습니다.</p>
                  <hr className={styles.divider}/>
                  <p className={styles.price}>6,590원<span className={styles.unit}>(100g당 659원)</span></p>
                </div>
                <div className={styles.rowAction}>
                  <Button type="primary" onClick={(e) => onCartClick(e, 'strawberry') } className={styles.btnCart}>장바구니 담기</Button>
                  <ButtonQuestion
                    content={() => {
                      return (
`${add_to_cart_strawberry}`
                        )
                      }}
                  />
                </div>
              </div>
            </div>
          </Card>
        </div>
        <div className={styles.colRight}>
          <div className={styles.cart}>
            <div className={styles.title}>
              <h3>장바구니</h3>
            </div>
            <div className="listEmpty">
              {
                (cartItems.length === 0) && (
                  <p>장바구니가 비어있습니다.</p>
                )
              }
            </div>
            <div className={styles.list}>
              {
                cartItems.includes('apple') && (
                  <div className={styles.listItem}>
                    <div className={styles.wrapThumbnail}>
                      <img className={styles.thumbnail} src="/ga4/apple.jpg"/>
                    </div>
                    <div className={styles.wrapItems}>
                      <div className={styles.name}>
                        <p>맛있는 사과입니다!</p>
                      </div>
                      <div className={styles.wrapPrice}>
                        <p className={styles.price}>가격: 4,100원</p>
                      </div>
                    </div>
                  </div>
                )
              }
              {
                cartItems.includes('strawberry') && (
                  <div className={styles.listItem}>
                    <div className={styles.wrapThumbnail}>
                      <img className={styles.thumbnail} src="/ga4/strawberry.jpg"/>
                    </div>
                    <div className={styles.wrapItems}>
                      <div className={styles.name}>
                        <p>맛있는 딸기입니다!</p>
                      </div>
                      <div className={styles.wrapPrice}>
                        <p className={styles.price}>가격: 6,590원</p>
                      </div>
                    </div>
                  </div>
                )
              }
            </div>
            {
              (cartItems.length !== 0) && (
                <>
                  <div className={styles.cartActions}>
                    <Button
                      style={{width: '100%', height: '60px'}}
                      onClick={(e) => onPurchaseClick(e)}
                      size="large" type="primary">{getTotalPrice()}원 구매하기</Button>
                  </div>
                  <div className={styles.questions}>
                    {
                      cartItems && (
                        <ButtonQuestion
                          content={() => {
                            return (
`${getPurchaseCode()}`
                            )
                          }}
                      />
                      )
                    }
                  </div>
                </>
              )
            }
          </div>
        </div>
      </div>
    </>
  )
}